import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class I140SubheaderService {

  constructor(private httpClient: HttpClient) { }
 
  saveSetting( caseType, caseId,payload) {
    return this.httpClient.post(`/${caseType}/task/${caseId}/filingtype/update`,payload).pipe(
        map((response: any) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        })
    );
}

getSetting( caseType, caseId) {
    return this.httpClient.get(`/${caseType}/task/${caseId}/filingtype`).pipe(
        map((response: any) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        })
    );
}
}



   
